import { render } from "./ContactDetailsView.vue?vue&type=template&id=4235a3b1"
import script from "./ContactDetailsView.vue?vue&type=script&lang=js"
export * from "./ContactDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__